//HOME
export const MARKETTOGGLE = 'MARKETTOGGLE'
export const LOADINGSCREEN = 'LOADINGSCREEN'
export const REQUEST_ALLOW = 'REQUEST_ALLOW'
export const SUBLOAD = 'SUBLOAD'
export const FULL_LOAD = 'FULL_LOAD'
export const CHANGE_SKIN_THEME = 'CHANGE_SKIN_THEME'
export const SHOW_FLOATING = 'SHOW_FLOATING'
export const SIM_DISP = 'SIM_DISP'
export const SPORTCOUNTMARKET = 'SPORTCOUNTMARKET'
export const IS_OTR = 'IS_OTR'
export const IS_RESULT = 'IS_RESULT'
export const SELECTEDBETTYPE = 'SELECTEDBETTYPE'
export const REFRESHSCREEN = 'REFRESHSCREEN'
export const IS_COLLAPSE = 'IS_COLLAPSE'
export const SHOWMOREEVENT = 'SHOWMOREEVENT'
export const FILTER_EVENT = 'FILTER_EVENT'
export const COOKIE_HISTORY = 'COOKIE_HISTORY'
export const SEARCH_LOADING = 'SEARCH_LOADING'
export const HIST_LIST = 'HIST_LIST'
export const CURRENT_TAB = 'CURRENT_TAB'

//ACCOUNT
export const ACCOUNT = 'ACCOUNT'
export const SELECTED_ODD = 'SELECTED_ODD'
export const ACC_CHIP_SETTING = 'ACC_CHIP_SETTING'
export const PASSCODE = 'PASSCODE'
export const TIME_ZONE  = 'TIME_ZONE'
export const ACCOUNT_FAV = 'ACCOUNT_FAV'

//SPORT
export const S_ODD = 'S_ODD'
export const SPORT_LIST = 'SPORT_LIST'
export const ALLSPORTCOUNT = 'ALLSPORTCOUNT'
export const SELECTED_MARKET = 'SELECTED_MARKET'
export const SPORTBETTYPELIST = 'SPORTBETTYPELIST'
export const LEAGUELIST = 'LEAGUELIST'
export const SELECTED_LEAGUE = 'SELECTED_LEAGUE'
export const EVENTLIST = 'EVENTLIST'
export const SELECTED_SORT = 'SELECTED_SORT'
export const SORTEDEVENTLIST = 'SORTEDEVENTLIST'
export const PARLAYDATELIST = 'PARLAYDATELIST'
export const OUTRIGHT_LEAGUELIST = 'OUTRIGHT_LEAGUELIST'
export const SELECTED_PAYLAY_DATE= 'SELECTED_PAYLAY_DATE'
export const SELECTED_EVENT = 'SELECTED_EVENT'
export const LIVELEAGUE = 'LIVELEAGUE'
export const LIVE_EVENTLIST = 'LIVE_EVENTLIST'
export const SPECIAL_EVENTLIST = 'SPECIAL_EVENTLIST'
export const SELECTED_LEAGUES = 'SELECTED_LEAGUES'
export const ARR_LEAGUES = 'ARR_LEAGUES'
export const SHOW_CALENDAR = 'SHOW_CALENDAR'
export const SEL_MATCH = 'SEL_MATCH'
export const PARLAY_TDYEVENTLIST = 'PARLAY_TDYEVENTLIST'
export const PARLAY_EARLYEVENTLIST = 'PARLAY_EARLYEVENTLIST'
export const IS_PARLAY = 'IS_PARLAY'
export const IS_SPECIAL = 'IS_SPECIAL'
export const IS_VIP = 'IS_VIP'
export const IS_PLACE_BET = 'IS_PLACE_BET'
export const IS_PROCESS_BET = 'IS_PROCESS_BET'
export const IS_MOBILE = 'IS_MOBILE'
export const TOTALPAGE = 'TOTALPAGE'
export const SELECTED_PAGE = 'SELECTED_PAGE'
export const GAMEBANNER_SELECTED = 'GAMEBANNER_SELECTED'
export const SPORT_ALL_EVENTS = 'SPORT_ALL_EVENTS'
export const IS_CORRECTSCORE = 'IS_CORRECTSCORE' 
export const SELECTED_STATE = 'SELECTED_STATE'
export const STATE_LIST = 'STATE_LIST'
export const PARLAY_SPORT_LIST = 'PARLAY_SPORT_LIST'
export const SPORT_SELECTED = 'SPORT_SELECTED'
export const FAVOURITEEVENT = 'FAVOURITEEVENT'
export const SELECTED_BETTYPE = 'SELECTED_BETTYPE'
export const SORTEDMATCHEVENTLIST = 'SORTEDMATCHEVENTLIST'
export const SORTEDFAVRBEVENTLIST = 'SORTEDFAVRBEVENTLIST'
export const SPORT_SHOW_FAV_EVENTS = 'SPORT_SHOW_FAV_EVENTS'
export const FAVOURITEALLBETEVENT = 'FAVOURITEALLBETEVENT'
export const EARLYCOUNT_BYDATE = 'EARLYCOUNT_BYDATE'
export const LOADGAMEHEADER = 'LOADGAMEHEADER'
export const SORTEDFAVOTREVENTLIST = 'SORTEDFAVOTREVENTLIST'
export const SELECT_ALL_LEAGUE = 'SELECT_ALL_LEAGUE'
export const SETTLE_UNSETTLED = 'SETTLE_UNSETTLED'
export const TODAYRBLEAGUELIST = 'TODAYRBLEAGUELIST'
export const TODAYRBEVENTLIST = 'TODAYRBEVENTLIST'
export const SORTEDTODAYRBEVENTLIST = 'SORTEDTODAYRBEVENTLIST'
export const HIDE_STATUS = 'HIDE_STATUS'
export const LABEL_STATUS = 'LABEL_STATUS'
export const SETFAVOURITE = 'SETFAVOURITE'
export const FILTERLEAGUELIST = 'FILTERLEAGUELIST'
export const SORTEDLEAGUELIST = 'SORTEDLEAGUELIST'
export const SELECTED_CHAR = 'SELECTED_CHAR'
export const COOKIE_LEAGUE = 'COOKIE_LEAGUE'
export const SELECTED_LEAGUELIST = 'SELECTED_LEAGUELIST'
export const FILTER_LEAGUE = 'FILTER_LEAGUE'
export const SELECTEDLEAGUES = 'SELECTEDLEAGUES'
export const TOTALLEAGUES = 'TOTALLEAGUES'
export const SELECTED_SPORT = 'SELECTED_SPORT'
export const SPORTLIST = 'SPORTLIST'
export const REFRESH_SPORTTABLE = 'REFRESH_SPORTTABLE'
export const OTREVENTLIST = 'OTREVENTLIST'
export const CHANGE_ODDS = 'CHANGE_ODDS'
export const SWIPE_MODE = 'SWIPE_MODE'
export const VIRTUAL_DATA_LIST = 'VIRTUAL_DATA_LIST'
export const IS_COLLAPSE_MATCH = 'IS_COLLAPSE_MATCH'
export const SHOW_END = 'SHOW_END'
export const SHOW_NOSCROLLEND = 'SHOW_NOSCROLLEND'
export const IS_HIDE_LEAGUE = 'IS_HIDE_LEAGUE'
export const SHOW_LEG_CAP = 'SHOW_LEG_CAP'
export const LEG_CAPT_DATA_LIST = 'LEG_CAPT_DATA_LIST'
export const DEFAULT_SPORT = 'DEFAULT_SPORT'
export const OTRHIDELGE_LIST = 'OTRHIDELGE_LIST'
export const OTRHIDETITLE_LIST = 'OTRHIDETITLE_LIST'
export const FAVOURITELGEVENT = 'FAVOURITELGEVENT'
export const OTRHIDEFAVLGE_LIST = 'OTRHIDEFAVLGE_LIST'
export const OTRHIDEFAVTITLE_LIST = 'OTRHIDEFAVTITLE_LIST'
export const IS_RESULT_SCHEDULE = 'IS_RESULT_SCHEDULE'
export const FILTER_SELECT_ALL = 'FILTER_SELECT_ALL'
export const HOT_MATCH_LIST = 'HOT_MATCH_LIST'

//ALLBET
export const ALLBETEVENT = 'ALLBETEVENT'
export const CSODDSEVENT = 'CSODDSEVENT'
export const REFRESHALLBET = 'REFRESHALLBET'

//BREADCUMB
export const SELECTED_TEMPLATE = 'SELECTED_TEMPLATE'
export const ARR_BREADCUMB = 'ARR_BREADCUMB'

//BETTINGFORM
export const BETTINGFORM_TOGGLE = 'BETTINGFORM_TOGGLE'
export const BETTING_SELECTION = 'BETTING_SELECTION'

//STATEMENT


//LIVE CHANNEL
export const LIVE_EVENT = 'LIVE_EVENT'
export const ALLOW_LANDSACPE = 'ALLOW_LANDSACPE'

//SYSTEM
export const GAME_BANNER_ID = 'GAME_BANNER_ID'
export const GAME_BANNER_SPORT_ID = 'GAME_BANNER_SPORT_ID'
//HEADER
export const SKIN_THEME = 'SKIN_THEME'
export const SORT_HOT = 'SORT_HOT'
export const ODDSFORMATDEC = 'ODDSFORMATDEC'
export const BETSLIPANY = 'BETSLIPANY'
export const EDITIONSTAND = 'EDITIONSTAND'
export const PREVIOUS_EDITION = 'PREVIOUS_EDITION'
export const SHOW_BTMODAL = 'SHOW_BTMODAL'
export const SHOW_FILTER ='SHOW_FILTER'
export const BETTER_ODDS = 'BETTER_ODDS'
export const FILTERTYPE ='FILTERTYPE'

// RESULT
export const RESULT_SPORT ='RESULT_SPORT'
export const RESULT_DATE ='RESULT_DATE'

// Promotion
export const PROMO_JOINED_FLAG = 'PROMO_JOINED_FLAG'
export const PROMO_FLAG = 'PROMO_FLAG'
export const PROMO_DETAILS = 'PROMO_DETAILS'
export const PROMO_SHOW_JOIN_SUCCESS = 'PROMO_SHOW_JOIN_SUCCESS'
export const PROMO_BET_STATUS = 'PROMO_BET_STATUS'
export const PROMO_BET_INDEX = 'PROMO_BET_INDEX'
export const PROMO_BET_WITHOUT_JOIN = 'PROMO_BET_WITHOUT_JOIN'
export const STATEMENT_SHOW_PROMOTIONDETAIL = 'STATEMENT_SHOW_PROMOTIONDETAIL'
export const PROMO_WAGER_DETAIL = 'PROMO_WAGER_DETAIL'


// WEBPACK FOOTER //
// ./resources/score/vue/store/mutation-types.js